import * as yup from 'yup';

export const useEmailValidation = () => {
  return {
    email: yup.string().trim().required('Введите e-mail').email('Некорректный e-mail'),
  };
};
